import React from "react";
import { usePagination, DOTS } from "./usePagination";
import { GrNext, GrPrevious } from "react-icons/gr";
import "./pagination.css";

const Pagination = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (!paginationRange || paginationRange.length < 2) {
    return null;
  }

  const lastPage = paginationRange[paginationRange.length - 1];

  return (
    <nav className="app-pagination-wrapper">
      <ul className="app-pagination">
        {/* Previous */}
        <li>
          <button
            className="app-pagination-btn"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <GrPrevious />
          </button>
        </li>

        {/* Pages */}
        {paginationRange.map((pageNumber, index) => {
          if (pageNumber === DOTS) {
            return (
              <li key={index} className="app-pagination-dots">
                …
              </li>
            );
          }

          return (
            <li key={index}>
              <button
                className={`app-pagination-page ${
                  pageNumber === currentPage ? "active" : ""
                }`}
                onClick={() => onPageChange(pageNumber)}
              >
                {pageNumber}
              </button>
            </li>
          );
        })}

        {/* Next */}
        <li>
          <button
            className="app-pagination-btn"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === lastPage}
          >
            <GrNext />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
